import {
  Box,
  ButtonBase,
  Dialog,
  Divider,
  Grid,
  Paper,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    maxWidth: '1200px',
    borderRadius: 16,
    backgroundColor: theme.palette.common.white,
  },
}));

export const DialogContainer = styled(Box)(() => ({
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  minWidth: 800,
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  height: '470px',
  overflowY: 'auto',
  backgroundColor: '#FAFCFF',
  border: '1px solid #0000003b',
  borderRadius: '16px',
  padding: '20px',
  '&::-webkit-scrollbar': {
    width: '12px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  '&::-webkit-scrollbar-track': {
    margin: '6px 0',
  },
  [theme.breakpoints.up('xl')]: {
    height: '652px',
  },
}));

export const StyledDivider = styled(Divider)(() => ({
  borderBottomWidth: '1px',
  borderBottomColor: '#D7D8DB',
  margin: '24px 0',
}));

export const SectionTitle = styled(Typography)(() => ({
  fontWeight: 600,
}));

export const ScrollableGrid = styled(Grid)(() => ({
  width: 900,
  maxHeight: '400px',
  overflowY: 'auto',
  padding: '4px',

  '& > .MuiGrid-item': {
    width: '100%',
    display: 'block',
  },

  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#8B8C8E',
    borderRadius: '4px',
  },
}));

export const ActionButton = styled(ButtonBase)(({ theme }) => ({
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '8px',
  padding: 8,
  color: theme.palette.secondary.main,
  span: {
    fontWeight: 600,
  },
  marginTop: 12,
}));

export const AddTypologyGroup = styled(ButtonBase)(({ theme }) => ({
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '8px',
  padding: '14px 40px',
  color: theme.palette.secondary.main,
  display: 'flex',
  gap: 8,
  fontSize: 16,
  span: {
    fontWeight: 600,
    fontSize: 16,
  },
  '&:disabled': {
    color: theme.palette.secondary.main,
    opacity: '40%',
  },
  minWidth: 180,
}));
